module.exports = __webpack_public_path__ + "2a7491e5d6ebf496dc5b3cc56cb38f01.jpg";